// extracted by mini-css-extract-plugin
export default {"container":"h1fSeo mz-default-dark-font","details":"dTqLl_"};